/**
 * Централизованная конфигурация API endpoints
 * Аналог lib/core/config/ из Flutter CRM
 */

export const API_CONFIG = {
  // Base URLs
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080',

  // Service endpoints
  AUTH_SERVICE: import.meta.env.VITE_AUTH_SERVICE_URL || 'http://localhost:8082',
  CLIENT_DATA_SERVICE: import.meta.env.VITE_CLIENT_DATA_URL || 'http://localhost:8083',
  DEALS_SERVICE: import.meta.env.VITE_DEALS_SERVICE_URL || 'http://localhost:8088',
  PROPERTIES_SERVICE: import.meta.env.VITE_PROPERTIES_URL || 'http://localhost:8081',
  COMMUNICATIONS_SERVICE: import.meta.env.VITE_COMMUNICATIONS_URL || 'http://localhost:8084',

  // CDN
  CDN_HOST: import.meta.env.VITE_CDN_HOST || 'http://localhost:8090',

  // Public Site
  SITE_HOST: import.meta.env.VITE_SITE_HOST || 'https://vinprop.vn',

  // Timeouts
  REQUEST_TIMEOUT: 30000,

  // API paths
  API_PREFIX: '/api/v1',
} as const

export type ApiService = keyof typeof API_CONFIG

export const getServiceUrl = (service: ApiService): string => {
  const url = API_CONFIG[service]
  return typeof url === 'string' ? url : ''
}

/**
 * Строит URL для CDN ресурса
 * @param path - Путь к ресурсу (например, "bd51c349-3504-4722-853a-15e53b667c02.jpeg")
 * @returns Полный URL CDN (например, "http://cdn.vinprop.vn/bd51c349-3504-4722-853a-15e53b667c02.jpeg")
 */
export const getCdnUrl = (path: string | undefined | null): string => {
  if (!path) {
    return ''
  }

  // Убираем ведущий слеш если есть
  const cleanPath = path.startsWith('/') ? path.slice(1) : path

  return `${API_CONFIG.CDN_HOST}/${cleanPath}`
}

/**
 * Строит публичный URL для жилого комплекса на основном сайте
 * @param citySlug - Slug города (например, "da-nang")
 * @param slug - Slug жилого комплекса
 * @param locale - Язык (по умолчанию "ru")
 * @returns Полный URL на основной сайт (например, "https://vinprop.vn/ru/properties/da-nang/{slug}")
 */
export const getPublicComplexUrl = (
  citySlug: string | undefined | null,
  slug: string | undefined | null,
  locale: string = 'ru',
): string => {
  if (!citySlug || !slug) {
    return ''
  }

  return `${API_CONFIG.SITE_HOST}/${locale}/properties/${citySlug}/${slug}`
}
